import { render, staticRenderFns } from "./addgmAuthority.vue?vue&type=template&id=f844b5f2&scoped=true&"
import script from "./addgmAuthority.vue?vue&type=script&lang=js&"
export * from "./addgmAuthority.vue?vue&type=script&lang=js&"
import style0 from "./addgmAuthority.vue?vue&type=style&index=0&id=f844b5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f844b5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f844b5f2')) {
      api.createRecord('f844b5f2', component.options)
    } else {
      api.reload('f844b5f2', component.options)
    }
    module.hot.accept("./addgmAuthority.vue?vue&type=template&id=f844b5f2&scoped=true&", function () {
      api.rerender('f844b5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/gmAuthorityYJ/components/addgmAuthority.vue"
export default component.exports